export const projectTransparencyData = [
  {
    title: "Impact dashboard",
    description:
      "View an in-depth breakdown of the data about our impact purchases and project types",
    link: {
      url: "https://lookerstudio.google.com/reporting/adfb141d-4153-4c22-b6b4-976f7f3930b2",
      title: "See impact dashboard",
    },
    image: {
      src: "/images/app/resources/transparency-card-impact.png",
      alt: "",
    },
  },
  {
    title: "Tree purchase evidence",
    description:
      "View purchase certificates from our reforestation partners for each of our tree orders",
    link: {
      url: "https://lookerstudio.google.com/reporting/adfb141d-4153-4c22-b6b4-976f7f3930b2/page/p_gjegi1xt3c",
      title: "See tree receipts",
    },
    image: {
      src: "/images/app/resources/transparency-card-tree-evidence.png",
      alt: "",
    },
  },
  {
    title: "Carbon purchase evidence",
    description:
      "View certificates for all of our purchases of carbon credits and their permanent retirements",
    link: {
      url: "https://lookerstudio.google.com/reporting/adfb141d-4153-4c22-b6b4-976f7f3930b2/page/p_lmu223yt3c",
      title: "See carbon offset receipts",
    },
    image: {
      src: "/images/app/resources/transparency-card-carbon-evidence.png",
      alt: "",
    },
  },
  {
    title: "Finance reports",
    description:
      "View our quarterly finance reports for an in-depth understanding of how much revenue we spend on impact",
    link: {
      url: "/articles/finance-reports",
      title: "See finance reports",
    },
    image: {
      src: "/images/app/resources/transparency-card-finance-report.png",
      alt: "",
    },
  },
  {
    title: "Impact reports",
    description:
      "View our annual impact reports which summarise the impact we've made in the previous year",
    link: {
      url: "/articles/impact-reports",
      title: "See impact reports",
    },
    image: {
      src: "/images/app/resources/transparency-card-impact-report.png",
      alt: "",
    },
  },
];
